import IParser from "@/types/IParser"
import { IMeterpointConsent } from "@/models/meterpointConsent/meterpointConsent.types"
import dayjs from "dayjs"
import ParseError from "@/types/ParseError"
import { safeDayjs } from "@/helpers/dateHelper"
import { MeterpointConsent } from "@/models/meterpointConsent/meterpointConsent"
import { ConsentResponse } from "@/api/backofficeRest/generated/model"

export type IMeterpointConsentRaw = ConsentResponse

export const MeterpointConsentParser: IParser<
  IMeterpointConsent,
  IMeterpointConsentRaw
> = {
  toDomain(data: IMeterpointConsentRaw): IMeterpointConsent {
    try {
      return new MeterpointConsent(
        data.consentDefinition,
        data.setting,
        data.meterPointIdentifier,
        dayjs(data.startDate),
        safeDayjs(data.endDate),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
